<template>
    <v-card class="ma-4">
      <v-card-text class="pa-0">
        <base-data-grid
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          @on-add-click="add"
          :exportFileName="title"
          :allowGrouping="false"
          :allowFilterPanel="false"
          :title="title"
        >
          <template slot="columnTemplates" slot-scope="row">
            <div v-if="row.data.field == 'State'">
              <span>{{ getState(row.data.item) }}</span>
            </div>
            <div v-if="row.data.field == 'Type'">
              <span>{{ getType(row.data.item) }}</span>
            </div>
          </template>
          <template slot="customActionTemplates" slot-scope="row">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  v-if="
                    row.data.item.State == dataManagementJobState.Done &&
                    (row.data.item.Type ==
                      dataManagementJobType.ExportWithMetadata ||
                      row.data.item.Type ==
                        dataManagementJobType.ExportOnlyFiles)
                  "
                  @click.prevent="download(row.data.item)"
                  class="pl-2 pr-2"
                >
                  <v-icon color="accent">mdi-download</v-icon>
                </a>
              </template>
              <span>{{ $t("Download") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  v-if="
                    row.data.item.State == dataManagementJobState.Pending ||
                    row.data.item.State == dataManagementJobState.Failed
                  "
                  @click.prevent="editItem(row.data.item)"
                  class="pl-2 pr-2"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </a>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="deleteItem(row.data.item)"
                  class="pl-2 pr-2"
                >
                  <v-icon color="red">mdi-delete</v-icon>
                </a>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>
          </template>
        </base-data-grid>
      </v-card-text>
    </v-card>
</template>

<script>
import DataManagementJobService from '@/services/DataManagementJobService';
import DataManagementJobType from '@/ecm/variables/DataManagementJobType';
import DataManagementJobState from '@/ecm/variables/DataManagementJobState';
import Utils from '@/ecm/common/Utils';

export default {
    props: {
        documentId: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            title: this.$t('DataManagement'),
            dataManagementJobState: DataManagementJobState,
            dataManagementJobType: DataManagementJobType,
            grid: {
                key: 'jobGrid',
                dataSource: DataManagementJobService.getGrid(),
                columns: [
                    {
                        field: 'Description',
                        caption: this.$t('Description'),
                        type: 'string',
                    },
                    {
                        field: 'Type',
                        caption: this.$t('Type'),
                        type: 'string',
                        hasTemplate: true,
                    },
                    {
                        field: 'ScheduledDateTime',
                        caption: this.$t('ScheduledTime'),
                        type: 'string',
                    },
                    {
                        field: 'State',
                        caption: this.$t('State'),
                        type: 'string',
                        hasTemplate: true,
                    },
                ],
            },
            modalKey: 'modalJob',
        };
    },
    computed: {
        gridInstance() {
            return this.$refs[this.grid.key];
        },
    },
    methods: {
        getState(data) {
            switch (data.State) {
            case DataManagementJobState.Pending:
                return this.$t('Pending');
            case DataManagementJobState.InProcess:
                return this.$t('InProcess');
            case DataManagementJobState.Done:
                return this.$t('Done');
            case DataManagementJobState.Failed:
                return this.$t('Failed');
            default:
                return '';
            }
        },
        getType(data) {
            switch (data.Type) {
            case DataManagementJobType.ExportWithMetadata:
                return this.$t('ExportWithMetadata');
            case DataManagementJobType.ExportOnlyFiles:
                return this.$t('ExportOnlyFiles');
            case DataManagementJobType.Delete:
                return this.$t('Site.DocumentManagement.Destroy');
            default:
                return '';
            }
        },
        download(dto) {
            DataManagementJobService.downloadExported(dto.Id);
        },
        deleteItem(dto) {
            this.$confirm(this.$t('ItemDeleteConfirmation'), {
                title: this.$t('Delete'),
                icon: 'mdi-alert',
                color: 'red',
                buttonTrueText: this.$t('Delete'),
                buttonFalseText: this.$t('Cancel'),
            }).then((res) => {
                if (res == 1) {
                    DataManagementJobService.delete(dto.Id).then((result) => {
                        if (result) {
                            this.gridInstance.refresh();
                            Utils.toast.success(this.$t('Job') + ' ' + this.$t('DeletedSuccessfully'));
                        }
                    });
                }
            });
        },
        editItem(dto) {
            this.$router.push({ path: `/administration/jobs/${dto.Id}` });
        },
        add() {
            this.$router.push({ path: '/administration/jobs/0' });
        },
        onItemSaved() {
            this.gridInstance.refresh();
        },
    },
};
</script>
